import React from "react";
import { Link, useLocation } from "react-router-dom";

class RouteErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidUpdate(prevProps) {
    if (this.state.hasError && prevProps.resetKey !== this.props.resetKey) {
      this.setState({ hasError: false });
    }
  }

  componentDidCatch(error, info) {
    console.error("Route render error:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <section className="route-error">
          <div className="container">
            <h1 className="heading">Something went wrong</h1>
            <p>Please refresh this page or go back to the homepage.</p>
            <Link to="/" className="theme-btn">Go Home</Link>
          </div>
        </section>
      );
    }

    return this.props.children;
  }
}

export default function RouteErrorBoundaryWithLocation({ children }) {
  const location = useLocation();
  return (
    <RouteErrorBoundary resetKey={location.pathname}>
      {children}
    </RouteErrorBoundary>
  );
}
